import Internship from './Internship';
export default Internship;
